import React from 'react';
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import GridLayout from '../grid-layout/GridLayout';
import styles from './SkeletonGrid.module.scss';

const Wrapper = ({ children }) => {
  return (
    <div className='mx-1 mx-md-3 pb-3 xs-width-100' style={{ display: "inline-flex" }}>{children}</div>
  );
};

export const SkeletonDocTile = ({count = 1, style = {}}) => {
  return (
    <SkeletonTheme duration={0.3} color="#ddd" >
      <Skeleton count={count} height={244} wrapper={Wrapper} style={style} className={'d-flex justify-content-center'}/>
    </SkeletonTheme>
  )
};

const SkeletonGrid = () => (
  <GridLayout className={styles.skeletonGrid}>
    {extraSmall =>
      <SkeletonDocTile count={10} style={{ width: extraSmall ? '80vw' : '200px', margin: 'auto' }}  />
    }
  </GridLayout>
);

export default SkeletonGrid;
